<template>
  <div>
  <base-table-box>
    <base-table
      class="custom-table"
      :columns="columns"
      :dataSource="tableData"
      :pagination="page"
      :rowKey="record => record.mienId"
      :loading="loading"
      @change="handleTableChange"
    >
      <template slot="mediaType" slot-scope="mediaType">
        <div v-if="mediaType === '1' ">图片</div>
        <div v-if="mediaType === '2' ">视频</div>
      </template>
      <template #operation="record">
        <a href="javascript: void 0;" class="text-btn" @click="seeRecord(record)">查看</a>
        <a href="javascript: void 0;" class="text-btn" @click="delRecord(record)">删除</a>
      </template>
    </base-table>
  </base-table-box>
  <a-modal
    title="企业风采"
    :visible="visible"
    destroyOnClose
    cancelText="关闭"
    :okButtonProps="{
      style:{
         display: 'none'
      }
    }"
    width="800px"
    :maskClosable="false"
    @cancel="cancel()"
  >
    <a-spin :spinning="loading">
      <a-form>
        <!--<a-form-item label="标题" v-bind="formItemLayout">-->
          <!--<a-input readOnly :value="mein.titleName"-->
          <!--/>-->
        <!--</a-form-item>-->
        <a-form-item label="图片" v-bind="formItemLayout" v-if="mein.mediaType=== '1'">
          <picture-card isPreview :fileList="imgList"/>
        </a-form-item>
        <a-form-item label="视频" v-bind="formItemLayout" v-if="mein.mediaType=== '2'">
          <a href="javascript: void 0;" class="text-btn" @click="openVideo(mein)">点击查看</a>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
  </div>
</template>

<script>
import { company } from '@/api'
export default {
  name: 'CompanyHonor',
  beforeCreate () {
    this.formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 15 }
    }
    this.columns = [
      {
        title: '类型',
        width: 120,
        dataIndex: 'mediaType',
        scopedSlots: {
          customRender: 'mediaType'
        }
      },
      {
        title: '操作',
        scopedSlots: {
          customRender: 'operation'
        }
      }
    ]
  },
  async mounted () {
    if (this.$route.params.id) {
      this.companyId = this.$route.params.id
    }
    await this.getTableData()
  },

  data () {
    return {
      imageUrl: process.env.VUE_APP_IMG,
      loading: false,
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      tableData: [],
      companyId: '',
      visible: false,
      imgList: [],
      mein: {}
    }
  },

  methods: {
    async getTableData () {
      this.loading = true
      let { code, msg, data, page } = await company.getCompanyHonorPage({
        companyId: this.companyId,
        type: '4',
        ...this.page
      })
      this.tableData = data
      this.loading = false
      if (code !== 0) return this.$message.error(msg || '数据获取失败')
      this.page.total = page.total
    },
    handleScreenSubmit () {
      this.page.current = 1
      this.getTableData()
    },
    handleReset () {
      this.screenForm.resetFields()
      this.page.current = 1
      this.getTableData()
    },
    handleTableChange ({ current }) {
      this.page.current = current
      this.getTableData()
    },
    delRecord ({ mienId }) {
      this.$confirm({
        title: '提示',
        content: '您确定要删除该荣誉信息吗?',
        okText: '确认',
        cancelText: '取消',
        onOk: async () => {
          let { code, msg } = await company.deleteCompanyHonor({
            mienId
          })
          if (code === 0) {
            this.$message.success('删除成功')
            this.getTableData()
          } else {
            this.$message.error(msg || '删除失败，请重试')
          }
        },
        onCancel () {}
      })
    },
    async seeRecord (record) {
      this.mein = record
      if (record.mediaType === '1' && record.mediaUrl) {
        this.imgList = record.mediaUrl.split(',')
      } else if (record.mediaType === '2' && record.mediaUrl) {
        this.imgList = []
      }
      this.visible = true
    },
    cancel () {
      this.mein = {}
      this.visible = false
    },
    openVideo (record) {
      window.open(this.imageUrl + record.mediaUrl, '_blank')
    }
  }
}
</script>

<style lang="less" scoped>
.table_name_info {
  display: flex;
  align-items: center;
  .table_name_img {
    flex: none;
    width: 60px;
    height: 60px;
    margin: 0px 12px 10px 0;
  }
}
</style>
